import { FieldHasValue } from 'helpers/Validation';

export const AsFoundResultFormula = (formData) => {
    if (
        FieldHasValue(formData.F402AftJumperWireAppliedAndShorted)
        && FieldHasValue(formData.F372AftHmistatus1)) {
        if (formData.F402AftJumperWireAppliedAndShorted === 'YES' && formData.F372AftHmistatus1 === 'ALARM') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
